import GamesHiveBackground from './gamesHiveBackground'

export default GamesHiveBackground